<template>
  <div class="searchGrade">
    <Header title="学生成绩"></Header>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="xm" label="姓名"> </el-table-column>
      <el-table-column prop="bjmc" label="班级"> </el-table-column>
      <el-table-column prop="kcmc" label="课程名称"> </el-table-column>
      <el-table-column prop="zcj" label="总成绩"> </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { Api } from "../../../../../utils/axios";
export default {
  data() {
    return {
      tableData: [],
      xnxq: this.$route.query.xnxq.dm,
      yx: this.$route.query.yx.dm,
      zy: this.$route.query.zy.dm,
      nj: this.$route.query.nj.dm,
      bj: this.$route.query.bj.dm,
      xm: this.$route.query.dm,
      kc: this.$route.query.kcmc
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      let data = {
        xnxq: this.xnxq ? this.xnxq : "",
        yx: this.yx ? this.yx : "",
        zy: this.zy ? this.zy : "",
        nj: this.nj ? this.nj : "",
        bj: this.bj ? this.bj : "",
        xm: this.xm ? this.xm : "",
        kc: this.kc ? this.kc : ""
      };
      console.log(data);
      const res = await Api.getXsCjList(data);

      this.tableData = res.data.dataList;
    }
  }
};
</script>

<style lang="less" scoped>
.searchGrade {
  padding: 0 20px;
}
</style>
<style lang="less">
.searchGrade {
  .el-table td {
    border-bottom: 1px solid #ebeef5 !important;
  }
  .el-table .warning-row {
    background: rgba(245, 108, 108, 0.4);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/grade/search/searchGrade.vue